import React from "react";
import { graphql, Link, navigate } from "gatsby";
import Grid from '@material-ui/core/Grid';

/* importing custom modules */
import Layout from '../components/layout';
import SEO from '../components/seo.js';
import ShareButton from '../components/Material-UI-Components/ShareButton.js';
import SubscribeFloatingButton from '../components/Custom Modules/SubscribeFloating';

import PersonIcon from '@material-ui/icons/Person';

export default function Template({ data }) {
  const post = data.markdownRemark;
  const { title, author, date, path, imagesrc } = post.frontmatter;

  const handleBackToBlogs = (event) => {
    event.preventDefault();
    navigate("/blog/");
  };

  return (
    <Layout>
      <SEO
        title={title}
        description={title}
        url={"https://www.pratiiti.in" + path}
        imageURL={imagesrc}
      />
      <Link to="/blog/" className="blogLink" onClick={handleBackToBlogs}>Back to Blogs</Link>
      <div className="how-to-diff-inner">
        <div className="width100">
          <div className="row">
            <Grid item xs={12} sm={12} md={12}>
              <div style={{marginBottom:'5%'}}></div>
              <div className="post-article">

                <article style={{borderBottom: 'solid 1px #ddd', marginBottom: 30}}>

                  <Grid item xs={12} sm={12} md={12} style={{textAlign: 'center', marginBottom: 20}}>
                    <h2 style={{color:'#f7941e'}}>{title}</h2>
                  </Grid>

                  <Grid container style={{textAlign: 'center'}}>
                    <Grid item xs={12} sm={6} md={6} style={{textAlign: '-webkit-auto'}}>
                      <PersonIcon
                        style={{
                          fontSize:30,
                          marginRight: 10,
                          color:'#f7941e',
                        }}/>
                      {"Posted by " + author}
                      <div className="publishedDate">Published on : {date}</div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                      <ShareButton shareUrl={"https://www.pratiiti.in" + path}/>
                    </Grid>
                  </Grid>
                </article>

                <div style={{marginBottom:'1%'}} dangerouslySetInnerHTML={{__html: post.html}}/>

              </div>
            </Grid>
          </div>
        </div>
      </div>
      <SubscribeFloatingButton/>
    </Layout>
  );
}

export const postQuery = graphql`
  query BlogPost($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path }}) {
      frontmatter {
        author
        date(formatString: "DD MMM YYYY")
        title
        path
        imagesrc
      }
      html
    }
  }
`;
